module.exports = __webpack_public_path__ + "img/popovtsev.a35f5970.jpg";